import { render, staticRenderFns } from "./Level3-1.vue?vue&type=template&id=1d8d5da2&scoped=true&"
import script from "./Level3-1.vue?vue&type=script&lang=js&"
export * from "./Level3-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d5da2",
  null
  
)

export default component.exports